import { theme } from "native-base";

export const IconTheme = {
    ...theme.components.Icon,
    baseStyle: {
        color: "gray.500",
    },
    defaultProps: {
        size: "sm",
    }
}